(function () {


	angular.module('app.widgets')
    .directive('plaFileModel', plaFileModel); 
    
    plaFileModel.$inject  = ['$parse'];

	function plaFileModel($parse) {
    return {
      restrict: 'A', //the directive can be used as an attribute only

      /*
       link is a function that defines functionality of directive
       scope: scope associated with the element
       element: element on which this directive used
       attrs: key value pair of element attributes
       */
      link: function (scope, element, attrs) {
          var model = $parse(attrs.plaFileModel),
              modelSetter = model.assign; //define a setter for demoFileModel

          //Bind change event on the element
          element.bind('change', function () {
              //Call apply on scope, it checks for value changes and reflect them on UI
              scope.$apply(function () {
                  //set the model value
                  modelSetter(scope, element[0].files[0]);
              });
          });
      }
    };
  }
})();